import { render, staticRenderFns } from "./ToiletBoxDetailScreen.vue?vue&type=template&id=44db04d5&scoped=true&lang=pug"
import script from "./ToiletBoxDetailScreen.vue?vue&type=script&lang=ts"
export * from "./ToiletBoxDetailScreen.vue?vue&type=script&lang=ts"
import style0 from "./ToiletBoxDetailScreen.vue?vue&type=style&index=0&id=44db04d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44db04d5",
  null
  
)

export default component.exports